import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/taxDeduction/taxDeductionData.json";

export default function TaxDeduction() {
  useSEO(seoConfig.taxDeduction);

  return (
    <section className="contacts taxdeduction">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Налоговый вычет за платные образовательные услуги
      </h1>

      <Accordion data={data} />
    </section>
  );
}
